import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/trabalhos")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="works"
      label="Trabalhos"
      slugSource="title"
      fields={[
        { name: "title", label: "Título", type: "text", required: true },
        { name: "slug", label: "Slug", type: "slug", required: true },
        { name: "summary", label: "Resumo", type: "textarea" },
        { name: "content", label: "Conteúdo", type: "richtext" },
        { name: "location", label: "Local", type: "text" },
        { name: "date", label: "Data", type: "date" },
        { name: "image_url", label: "Imagem", type: "image" },
        { name: "image_alt", label: "Texto alternativo", type: "text" },
        { name: "video_url", label: "Vídeo (URL)", type: "text" },
        { name: "featured", label: "Destaque", type: "boolean" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "title", label: "Título" },
        { key: "location", label: "Local" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
